export default __webpack_public_path__ + "static/Greycliffcf-bold-webfont-eb0c214fe2ccf3c32c6250cf29e7a9bf.woff2";